<div class="dashboard-add-container">
    <div class="sticky-header">
        <div
            class="button-wrap"
            *ngIf="!responsive.isXLarge() && !responsive.isLarge()"
        >
            <button
                class="caption transparent highlighted-text"
                (click)="emitClose()"
            >
                {{ "dashboard.forms.add-panel.labels.cancel" | translate }}
            </button>
            <button
                class="caption primary"
                (click)="emitSave()"
                [disabled]="!isAnySelected()"
            >
                {{ "dashboard.forms.add-panel.labels.save" | translate }}
            </button>
        </div>
        <div class="search-wrapper">
            <app-labelled-block-input-wrapper
                [icon]="'search'"
                header="{{
                    'dashboard.forms.add-panel.input.header' | translate
                }}"
                class="input-wrapper"
            >
                <input
                    type="text"
                    class="text"
                    style="width: 100%"
                    #wrapTarget
                    [(ngModel)]="searchInput"
                    (input)="handleSearchInputUpdate()"
                    placeholder="{{
                        'dashboard.forms.add-panel.input.placeholder'
                            | translate
                    }}"
                />
            </app-labelled-block-input-wrapper>
        </div>

        <div [hidden]="responsive.isXSmall()">
            <app-bubble-selector
                [options]="typeFilters"
                [extractLabelFn]="getTypeFilterLabel"
                (onSelectionChange)="handleFiltersUpdated($event)"
            ></app-bubble-selector>
        </div>
        <div
            [hidden]="
                responsive.isLarge() ||
                responsive.isXLarge() ||
                !isAnySelected()
            "
            (click)="onPreview()"
        >
            <div class="preview-btn">
                <mat-icon svgIcon="preview"></mat-icon>
                <span class="caption">{{
                    "dashboard.forms.preview.header" | translate
                }}</span>
            </div>
        </div>
    </div>

    <div class="panel-list">
        <!-- Alarm Pages -->
        <ng-container *ngIf="isTypeVisible(DashboardPanelType.ALARMS)">
            <div
                *ngFor="let pageName of filteredAlarmPages"
                class="panel-entry"
                [ngClass]="{ selected: isAlarmSelected() }"
                (click)="handleAlarmSelected()"
            >
                <div>
                    <mat-icon svgIcon="alarm-page"></mat-icon>
                </div>
                <div class="panel-label-wrap">
                    <span data-cy="dashboard-custom-page-alarm-element-type" class="caption light panel-list-label">{{
                        "dashboard.forms.add-panel.labels.section-alarm"
                            | translate
                    }}</span>
                    <span data-cy="dashboard-custom-page-alarm-element-name" class="caption bold highlighted-text">
                        {{ pageName }}</span
                    >
                </div>
            </div>
        </ng-container>

        <!-- Trend Graphs -->
        <ng-container *ngIf="isTypeVisible(DashboardPanelType.TREND_GRAPH)">
            <div
                *ngFor="let graph of filteredTrendGraphs"
                class="panel-entry"
                [ngClass]="{ selected: isGraphSelected(graph) }"
                (click)="handleTrendGraphSelected(graph)"
            >
                <div>
                    <mat-icon svgIcon="trendgraph"></mat-icon>
                </div>
                <div class="panel-label-wrap">
                    <span data-cy="dashboard-custom-page-trend-graph-element-type" class="caption light panel-list-label">{{
                        "dashboard.forms.add-panel.labels.section-trend-graph"
                            | translate
                    }}</span>
                    <span data-cy="dashboard-custom-page-trend-graph-element-name" class="caption bold highlighted-text">
                        {{ graph.name }}</span
                    >
                </div>
            </div>
        </ng-container>

        <!-- Channel Groups -->
        <ng-container *ngIf="isTypeVisible(DashboardPanelType.CHANNEL_GROUP)">
            <div
                *ngFor="let group of filteredChannelGroups"
                class="panel-entry"
                [ngClass]="{ selected: isChannelGroupSelected(group) }"
                (click)="handleChannelGroupSelected(group)"
            >
                <div>
                    <mat-icon svgIcon="channel-list"></mat-icon>
                </div>
                <div class="panel-label-wrap">
                    <span data-cy="dashboard-custom-page-channel-group-element-type" class="caption light panel-list-label">{{
                        "dashboard.forms.add-panel.labels.section-channel-list"
                            | translate
                    }}</span>
                    <span data-cy="dashboard-custom-page-channel-group-element-name" class="caption bold highlighted-text">
                        {{ group.displayName }}</span
                    >
                </div>
            </div>
        </ng-container>

        <!-- Custom Groups -->
        <ng-container *ngIf="isTypeVisible(DashboardPanelType.CHANNEL_GROUP)">
            <div
                *ngFor="let group of filteredCustomGroups"
                class="panel-entry"
                [ngClass]="{ selected: isCustomGroupSelected(group) }"
                (click)="handleCustomGroupSelected(group)"
            >
                <div>
                    <mat-icon svgIcon="channel-list"></mat-icon>
                </div>
                <div class="panel-label-wrap">
                    <span data-cy="dashboard-custom-page-custom-channel-group-element-type" class="caption light panel-list-label">{{
                        "dashboard.forms.add-panel.labels.section-channel-list"
                            | translate
                    }}</span>
                    <span data-cy="dashboard-custom-page-custom-channel-group-element-name" class="caption bold highlighted-text">
                        {{ group.displayName }}</span
                    >
                </div>
            </div>
        </ng-container>

        <!-- MIMICS -->
        <ng-container *ngIf="isTypeVisible(DashboardPanelType.MIMICS)">
            <div
                *ngFor="let mimic of filteredMimics"
                class="panel-entry"
                [ngClass]="{ selected: isMimicSelected(mimic) }"
                (click)="handleMimicSelected(mimic)"
            >
                <div>
                    <mat-icon svgIcon="mimics"></mat-icon>
                </div>
                <div class="panel-label-wrap">
                    <span data-cy="dashboard-custom-page-mimic-element-type" class="caption light panel-list-label">{{
                        "dashboard.forms.add-panel.labels.section-mimics"
                            | translate
                    }}</span>
                    <span data-cy="dashboard-custom-page-mimic-element-name" class="caption bold highlighted-text">
                        {{ mimic.name }}</span
                    >
                </div>
            </div>
        </ng-container>
    </div>
</div>
